import { gql } from "@apollo/client";

export const CreateToastMessage = gql`
    mutation CreateToastMessage ($input: ToastMessageCreateAttributesInput!){
        createToastMessage(input: $input) {
            id
            message
            fromDate
            toDate
            status
        }
    }
`;
